module.exports = __webpack_public_path__ + "static/img/xiaojun2.0430b33.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/xiaojun2.png
// module id = DYeL
// module chunks = 1